module.exports = __webpack_public_path__ + "img/section4.ff1eac48.jpg";